(() => {
  // Sélecteur de formules : chaque carte fixe la quantité envoyée au panier.
  // La gratuité est appliquée par la remise automatique Shopify (voir notes de la section).
  document.querySelectorAll('[data-dp-offers]').forEach((box) => {
    const form = box.closest('form');
    if (!form) return;
    const dataEl = box.querySelector('[data-dp-variants]');
    let variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    const currency = box.dataset.currency || 'EUR';
    const locale = document.documentElement.lang || 'fr';
    const fmt = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    const qtyInput = form.querySelector('input[name="quantity"]');
    const btn = form.querySelector('[data-add]');
    const radios = [...box.querySelectorAll('input[type="radio"]')];

    const currentVariant = () => {
      const id = Number((form.querySelector('[name="id"]') || {}).value);
      return variants.find((v) => v.id === id) || variants[0];
    };

    const render = () => {
      const v = currentVariant();
      const checked = radios.find((r) => r.checked) || radios[0];
      if (!v || !checked) return;
      radios.forEach((r) => {
        const paid = Number(r.dataset.paid || r.dataset.qty);
        const qty = Number(r.dataset.qty);
        const card = r.closest('.dp-offer');
        const total = card.querySelector('[data-dp-total]');
        const unit = card.querySelector('[data-dp-unit]');
        if (total) total.textContent = fmt(v.price * paid);
        const value = card.querySelector('[data-dp-value]');
        const saving = card.querySelector('[data-dp-saving]');
        if (value) value.textContent = fmt(v.price * qty);
        if (saving) saving.textContent = `Économisez ${fmt(v.price * (qty - paid))}`;
        if (unit) unit.textContent = qty > 1 ? `${fmt(Math.round((v.price * paid) / qty))} / tapis` : '';
      });
      const qty = Number(checked.dataset.qty);
      const paid = Number(checked.dataset.paid || qty);
      if (qtyInput) qtyInput.value = String(qty);
      if (btn && v.available && btn.dataset.inStock) {
        const struck = qty > paid ? ` <s>${fmt(v.price * qty)}</s>` : '';
        btn.innerHTML = `<span>${btn.dataset.inStock}</span><span class="dp-btn-price">${struck} ${fmt(v.price * paid)}</span>`;
      }
    };

    radios.forEach((r) => r.addEventListener('change', render));
    // Le thème met à jour la variante sur "change" : on repasse juste après lui.
    form.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('[data-option]')) setTimeout(render, 0);
    });
    form.querySelectorAll('.variant-options label').forEach((l) => l.addEventListener('click', () => setTimeout(render, 0)));
    // Après un ajout au panier, le thème réécrit le libellé du bouton : on le recalcule.
    form.addEventListener('submit', () => setTimeout(render, 1500));
    render();
  });

  // Liens d'ancre vers l'offre : défilement sous l'en-tête collant.
  document.querySelectorAll('a[href="#product"], a[href="#offres"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const target = document.getElementById('offres') || document.getElementById('product');
      if (!target) return;
      e.preventDefault();
      const header = document.querySelector('.header.is-sticky');
      const y = target.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight + 12 : 12);
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });
})();
